import { getLocale } from "../runtime";

const sv_lvcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Lettland`
};

const lvcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_lvcountry(inputs)
	return "lvCountry";
};

export { lvcountry as "lvCountry" };